// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */
import { createAsyncAction } from 'typesafe-actions';
import { Note } from '../../../types/Model'

export interface CreateOnlineCourseNoteRequestPayload {
  id: number; // course id
  vodId: number;
  time: number;
  message: string;
}

export interface CreateOnlineCourseNoteSuccessPayload {
  id: number;
  notes: Note[];
}

export interface CreateOnlineCourseNoteFailPayload {
  error: Error;
}

const createOnlineCourseNoteActions = createAsyncAction(
  'elearning/CREATE_ONLINE_COURSE_NOTE_REQUEST',
  'elearning/CREATE_ONLINE_COURSE_NOTE_SUCCESS',
  'elearning/CREATE_ONLINE_COURSE_NOTE_FAIL'
)<CreateOnlineCourseNoteRequestPayload, CreateOnlineCourseNoteSuccessPayload, CreateOnlineCourseNoteFailPayload>();

export { createOnlineCourseNoteActions as default};
